export const zIndex = {
  backdrop: 200,
  popup: 300,
  element: 400,
  module: 500
};
